// TODO remove this temporary approach for error handling when there is proper server error handling.
export const checkErrorSatusCode = (
  statusCode: number,
  clientErrorMessage: string,
  serverErrorMessage: string,
): string => {
  if (statusCode >= 400 && statusCode < 500) return clientErrorMessage;
  if (statusCode >= 500) return serverErrorMessage;
  return '';
};
